import { IconName } from '@fortawesome/fontawesome-svg-core'

const ALLOWED_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/bmp',
  'image/tiff',
  'image/webp',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/csv',
  'text/plain',
  'application/json',
]

const ALLOWED_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'bmp',
  'tiff',
  'tif',
  'webp',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'csv',
  'txt',
  'json',
]

export const CHAT_ATTACHMENT_ACCEPT = [...ALLOWED_MIME_TYPES, ...ALLOWED_EXTENSIONS.map((ext) => `.${ext}`)].join(',')

// Works on names and urls: '' when the last path segment has no extension (no host/path fragments).
export const getFileExtension = (filename: string): string =>
  /\.([^./?#]+)(?:[?#].*)?$/.exec(filename)?.[1].toLowerCase() ?? ''

// FontAwesome icon name per file extension (fallback: generic 'file').
export const getFileIcon = (filename: string): IconName => {
  const iconMap: Record<string, IconName> = {
    pdf: 'file-pdf',
    xls: 'file-excel',
    xlsx: 'file-excel',
    csv: 'file-excel',
    doc: 'file-word',
    docx: 'file-word',
    ppt: 'file-powerpoint',
    pptx: 'file-powerpoint',
    zip: 'file-archive',
    rar: 'file-archive',
    jpg: 'file-image',
    jpeg: 'file-image',
    png: 'file-image',
    gif: 'file-image',
    webp: 'file-image',
    txt: 'file-lines',
    json: 'file-code',
  }
  return iconMap[getFileExtension(filename)] || 'file'
}

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
